import { InvitationDTO } from '../InvitationDTO';
import { MemberDTO } from './MemberDTO';

export interface ListMember {
  status?: string;
  success?: boolean;
  members?: Array<MemberDTO>;
  invitations?: Array<InvitationDTO>;
}

export const GenderEnum = {
  MALE: 'Monsieur',
  FEMALE: 'Madame',
};
